import { ApiClientService, EntityApiService } from '@dfl/react-security';
import { ICurrencySettings } from 'modules/sales/settings/payment-settings/interfaces';

class PaymentSettingsService extends EntityApiService<ICurrencySettings> {
  getCurrency = (params?: any) => {
    return this.handleResponse(ApiClientService.get('/ms-pay/api/public/payment-settings/currency', params));
  };

  findCurrency = (params?: any) => {
    return this.handleResponse(ApiClientService.get(this.getPath(''), params));
  };

  activitySearch = (params?: any, config?: any) => {
    return this.handleResponse(ApiClientService.post(this.getPath('/activity/search'), params, config));
  };
}

export default new PaymentSettingsService('/ms-pay/api/payment-settings/currency');
